/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React from 'react'
import {
  Link
} from "react-router-dom"
import { getScrollHeight, getScrollLimit, getScrollPosition } from 'utils/scrolling'
import { getSvgIcon } from '../resources'
import AppStyle from '../scss/main/App.module.scss'
import { RootState } from 'store/types'
import { useSelector } from 'react-redux'
import moment from 'moment'

let footerY: number = 50;
const Bottom: React.FC<{}> = () => {

  const scrollY = useSelector((state: RootState) => state.ui.scrollY);

  const currentY = Math.abs(getScrollPosition())
  if (currentY >= (getScrollLimit() - getScrollHeight())) {
    const startY = currentY - (getScrollLimit() - getScrollHeight())
    footerY = 50 - (((startY / getScrollHeight()) / 2) * 100)
  } else if (footerY !== 50) {
    footerY = 50
  }

  return (
    <div className={AppStyle["footer"]}>
      <div style={{willChange: footerY < 50 ? 'transform' : 'unset', transform: `translate3d(0px, -${footerY}%, 0px)`}}>
        <div>
          <div>
            <div>
              Have an idea?
            </div>
            <Link to="/contact">Tell me about it</Link>
          </div>
        </div>
        <div>
          <div>
            <div>
              <div>
                <a href='mailto:info@samjay.dev?subject=[Enquiry: samjay.dev] Your enquiry title'>
                  info@samjay.dev
                </a>
              </div>
              <div>
                Hong Kong
              </div>
              <div>
                <div>Design by Sam TSANG</div>
                <div>© {moment().year()} SAMJAY.DEV</div>
              </div>
            </div>
            <div>
              <div>
                <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'github' })}` }} onClick={() => {
                  window.open("https://github.com/samjayhk", "_blank");
                }} />
                <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'linkedin' })}` }} onClick={() => {
                  window.open("https://www.linkedin.com/in/samjayts", "_blank");
                }} />
                <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'teams' })}` }} onClick={() => {
                  window.open("https://teams.live.com/l/invite/FEA8kBtLW4S4Nj53QE", "_blank");
                }} />
                 <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'whatsapp' })}` }} onClick={() => {
                  window.open("https://api.whatsapp.com/send?phone=85290107715", "_blank");
                }} />
                <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'tg' })}` }} onClick={() => {
                  window.open("https://telegram.me/samjayts", "_blank");
                }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Bottom